import { request } from 'helpers/api';
import is from 'helpers/is';
import templates from './mocks/templates';

export const STRIPE_KEY = is().prod
  ? 'pk_live_12Hfp2xMw6pmtY2XwqTV9ekj'
  : 'pk_test_R3ac3Nr3DKLCj5j0407flAdC';

export const getPlanDetails = () => request.get('plan');
export const postContactDetails = (data) => request.post('contact', data);
export const postCV = (data) => request.post('cv', data);

export const apiPasswordRecovery = {
  reset: (data) => request.post('password-reset', data),
  confirm: (data) => request.put('password-reset', data),
};

export const apiLogin = {
  authoriseAs: (data, type) => request.post(`${type}/auth`, data),
  authorise: (data) => request.post('auth', data),
};

export const apiRegister = {
  postMember: (data, type) => request.post(`${type}`, data),
  checkEmail: (data, type) => request.post(`${type}/email-check`, data),
};

export const apiCheckout = {
  getAccountDetails: (type, uid) => request.get(`${type}/${uid}`),
  updateAccountDetails: (type, uid, data) =>
    request.put(`${type}/${uid}`, data),
  createPayment: (type, uid, data) =>
    request.post(`${type}/${uid}/payment`, data),
};

/**
 * mocked fetch templates api call
 */
export const fetchTemplates = () => Promise.resolve(templates);
